import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import PurchaseHistoryRow from './PurchaseHistoryRow';

interface PurchaseHistoryTableProps {
  orders: any[];
}

const PurchaseHistoryTable: React.FC<PurchaseHistoryTableProps> = ({ orders }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Order ID</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Total Price</TableCell>
            <TableCell>Items</TableCell>
            <TableCell>Customer Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((order) => (
            <PurchaseHistoryRow key={order.id} order={order} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PurchaseHistoryTable;
